import { render, staticRenderFns } from "./researchObjectList.vue?vue&type=template&id=24607bdb&scoped=true"
import script from "./researchObjectList.vue?vue&type=script&lang=js"
export * from "./researchObjectList.vue?vue&type=script&lang=js"
import style0 from "./researchObjectList.vue?vue&type=style&index=0&id=24607bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24607bdb",
  null
  
)

export default component.exports